const purple = "#5236AB";

const styles = {
  dialogBackdrop: {
    backgroundColor: "rgba(0,0,0,0.45)",
    backdropFilter: "blur(4px)",
  },
  dialogPaper: {
    borderRadius: 0,
    p: 0,
  },
  container: {
    p: 3,
    display: "grid",
    justifyItems: "center",
    gap: 2,
    textAlign: "center",
  },
  title: {
    m: 0,
    fontWeight: 700,
  },
  body: {
    m: 0,
  },
  countdownPill: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 9999,
    backgroundColor: "#F3F0FF",
    color: purple,
    fontSize: "0.78rem",
    fontWeight: 600,
    letterSpacing: 0.2,
    fontVariantNumeric: "tabular-nums",
  },
  actionsRow: {
    display: "flex",
    justifyContent: "center",
    gap: 2,
  },
  btnPurple: {
    bgcolor: purple,
    color: "#fff",
    "&:hover": { bgcolor: purple, color: "#fff" },
  },
  btnGrey: {
    bgcolor: "#f0f0f0",
    color: purple,
    "&:hover": { bgcolor: "#f0f0f0", color: purple },
  },
};

export default styles;
